<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增账号' : '编辑账号'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="200px"
        size="mini"
      >
        <el-form-item label="用户名：">
          <el-input
            :disabled="!this.value.isCreate"
            v-model="form.username"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="角色：" prop="status">
          <el-select
            v-model="form.role"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址类型：" prop="addressType">
          <el-select
            @change="addressTypeChange"
            style="width: 150px"
            v-model="form.addressType"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableAddressTypes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <span v-if="form.addressType == '企业微信'">
            <span class="link-button" @click="openGetUserIdDialog()"
              >点击获取通知地址</span
            >
          </span>
        </el-form-item>
        <el-form-item label="通知地址：" prop="">
          <el-input
            :disabled="form.addressType == '企业微信'"
            v-model="form.address"
            clearable
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="参与敏感业务操作的投票"
          prop="isReceiveCorpNotifications"
        >
          <el-switch
            v-model="form.isReceiveCorpNotifications"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="敏感业务操作需要经过投票："
          prop="isAuditedWithOperation"
        >
          <el-switch
            v-model="form.isAuditedWithOperation"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px">{{
          this.value.isCreate ? "确定" : "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        id: "0",
        username: "",
        role: "运营",
        address: "",
        addressType: "",
        isReceiveCorpNotifications: true,
        isAuditedWithOperation: true,
      },
      roleOptions: [],
      rules: {
        username: [{ required: true, message: " ", trigger: "blur" }],
      },
      availableAddressTypes: [],
    };
  },

  props: {
    value: Object,
  },

  components: {},

  async created() {
    await this.loadAvailableAddressTypes();

    for (let role of await this.$bizutil.loadRoles()) {
      this.roleOptions.push({
        label: role.name,
        value: role.name,
      });
    }

    if (!this.value.isCreate) {
      this.form = this.value.oldData;
    }
  },

  methods: {
    async loadAvailableAddressTypes() {
      this.availableAddressTypes = [];
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpMemberAddressTypes`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.types || [];
      for (let item of listInResponse) {
        this.availableAddressTypes.push(item);
      }
    },
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.add();
      } else {
        this.edit();
      }
    },

    /**
     * 新增
     */
    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增账号“${this.form.username}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addAdmin`,
            {
              entry: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;

        // 弹确认框
        await this.$confirm(
          `用户“${this.form.username}”的新密码: ${resData.data.password}`,
          { showCancelButton: false, confirmButtonText: "复制链接" }
        ).then(() => {
          try {
            let txt =
              `${this.$bizutil.getProjectName()}后台：` +
              `\n` +
              `- 地址：${this.$util.getBackendApiBase()}/admin/` +
              `\n` +
              `- 账号：${this.form.username}` +
              `\n` +
              `- 密码：${resData.data.password}` +
              `\n` +
              `（登录后可在右上角修改密码）`;

            navigator.clipboard.writeText(txt);
            this.$message({
              message: "复制成功",
              type: "success",
            });
          } catch (err) {
            this.$message.error("复制失败： " + JSON.stringify(err));
          }
        });
      } catch (e) {}
    },

    async edit() {
      try {
        // 弹确认框
        await this.$confirm(`确认更新账号“${this.form.username}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateAdministrator`,
            {
              entry: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "更新成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },
    addressTypeChange() {
      this.form.address = "";
    },
    async openGetUserIdDialog() {
      this.$dialogutil.open("GetUserIdDialog", {
        closedCallback: (param) => {
          if (param != null) {
            this.form.address = param;
          }
        },
        data: { addressType: this.form.addressType, app: "notify" },
      });
    },
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>